const REFERRAL_CODE_KEY = "@fundamentei/referralCode";

export function captureReferralCode() {
  if (typeof window === "undefined") {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get("ref");

  if (refCode) {
    try {
      localStorage.setItem(REFERRAL_CODE_KEY, refCode);
      return refCode;
    } catch {
      // localStorage might be unavailable in private browsing
      return null;
    }
  }

  return getReferralCode();
}

export function getReferralCode() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(REFERRAL_CODE_KEY);
  } catch {
    return null;
  }
}

export function clearReferralCode() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(REFERRAL_CODE_KEY);
  } catch {
    // Ignore errors - localStorage might be unavailable
  }
}
